module.exports = __webpack_public_path__ + "739eec58e783f55b150da76a100f25ab.svg";